// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyCardFinderPatientResponse {
    static getAttributeTypeMap() {
        return PharmacyCardFinderPatientResponse.attributeTypeMap;
    }
}
PharmacyCardFinderPatientResponse.discriminator = undefined;
PharmacyCardFinderPatientResponse.additionalProperties = false;
PharmacyCardFinderPatientResponse.attributeTypeMap = [
    {
        "name": "birthDate",
        "baseName": "birthDate",
        "type": "string"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "middleName",
        "baseName": "middleName",
        "type": "string"
    },
    {
        "name": "suffix",
        "baseName": "suffix",
        "type": "string"
    },
    {
        "name": "zipCode",
        "baseName": "zipCode",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyCardFinderPatientResponse.js.map